<template>
  <div class="hello">
    <div class="notify-container" v-if="notifyTitle">
      <div class="header-box">
        <span class="notify-text">{{notifyTitle}}</span>
        <span class="notify-time">{{notifyStartTime}}</span>
      </div>
      <div class="content-box">
        <div id="notify-content" v-dompurify-html="notifyContent"></div>
      </div>
      <div class="footer-box">
        <span class="btn" @click="cancelWait">离开</span>
        <div class="btn" :class="[countDown!==0?'disable':'ok']" :style="{'background':countDown!==0?'#ccc':boxBodyColor}" @click="jumpTo">
          <span v-show="countDown!==0">{{countDown}}s </span>
          <span>进入</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import md5 from 'js-md5'
import * as Url from '@/components/url.js'
Date.prototype.format = function(format){
  var o = {
    "M+" : this.getMonth()+1, //month
    "d+" : this.getDate(), //day
    "h+" : this.getHours(), //hour
    "m+" : this.getMinutes(), //minute
    "s+" : this.getSeconds(), //second
    "q+" : Math.floor((this.getMonth()+3)/3), //quarter
    "S" : this.getMilliseconds() //millisecond
  }

  if(/(y+)/i.test(format)) {
    format = format.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length));
  }

  for(var k in o) {
    if(new RegExp("("+ k +")").test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length==1 ? o[k] : ("00"+ o[k]).substr((""+ o[k]).length));
    }
  }
  return format;
}

var vm = {}
export default {
  name: 'hello',
  data () {
    vm = this
    return {
      basicUrl:Url.baseurl,
      visitorMd5Code:'',
      redirectTarget:'',
      imEntranceMode:'',
      status:'',
      notifyTitle: "",
      notifyStartTime: '',
      notifyContent: "",
      countDown: 3,
      timer: null,
      boxBodyColor: ""
    }
  },
  mounted () {
    this.initConfig(1)
  },
  methods: {
    initConfig(customFlag) {
      var obj = {};
      var os = this.getOs()
      obj.os = os;
      console.log(window.location.href,'看看url');

      var a = decodeURI(window.location.href, 'utf-8')
      console.log(window.location.href,typeof(a),os,'ssss')
      var serviceKey =  a.split('?')[1].split('&')[0].split('=')[1];
      var secretKey =  a.split('?')[1].split('&')[1].split('=')[1];
      var boxBodyColor = a.split('?')[1].split('&')[2].split('=')[1];
      this.boxBodyColor = boxBodyColor || "#009588";
      var companyName = a.split('?')[1].split('&')[3].split('=')[1];
      var logoUrl = a.split('?')[1].split('&')[4].split('=')[1];
      if(logoUrl == ''){
        logoUrl = 'https://visitor.one.cn/pc/static/assets/logo.png'
      }
      var displayMode = a.split('?')[1].split('&')[5].split('=')[1];
      console.log(displayMode);
      var account = ''
      var vip = ''
      var extendInfo = '';

      if(a.split('?')[1].split('&').length > 6 && a.split('?')[1].split('&').length!=7){

        if(a.split('?')[1].split('&')[6].split('=')[1] != 'null'){
          account = decodeURIComponent(a.split('?')[1].split('&')[6].split('=')[1]);
          obj.account = account;
        }else{
          obj.account = '';
        }

        if(a.split('?')[1].split('&')[7].split('=')[1] != 'null'){
          vip = a.split('?')[1].split('&')[7].split('=')[1];
          obj.vip = vip+'';
        }else {
          obj.vip = '';
        }
        if(a.split('?')[1].split('&')[8].split('=')[1] != 'null'){

          extendInfo = encodeURI(a.split('?')[1].split('&')[8].split('=')[1])
        }

      }else{
        obj.account = '';
        obj.vip = '';
      }

      sessionStorage.setItem("thisuserinfo", JSON.stringify(obj));
      sessionStorage.setItem('boxBodyColor',boxBodyColor)

      sessionStorage.setItem('companyName',companyName)

      sessionStorage.setItem('logoUrl',logoUrl)
      sessionStorage.setItem('displayMode',displayMode)

      //console.log(account,'zhendefan')
      console.log(extendInfo,typeof(extendInfo))

      var date = Date.parse(new Date())

      var code = md5(serviceKey+secretKey+5+os+date);

      function zhyi(a){
        //console.log(a);
        var b = a.replace(/~/g,'%7E');
        //console.log(b);

        return b;
      }

      var ss = 'account='+encodeURI(account)+'&os='+os+'&platform=5'+'&vipLevel='+vip+'&serviceKey='+serviceKey+'&currentTime='+date+'&code='+code
      // +'&extendInfo='+extendInfo
      var abc =encodeURIComponent(ss);
      console.log('--------------------------------------')
      console.log(ss)
      console.log('--------------------------------------')
      console.log(zhyi(abc));
      console.log('--------------------------------------')
      var sign = md5(zhyi(abc));
      vm.axios.get(vm.basicUrl + '/api/v2/visitor/index?serviceKey=' + serviceKey + '&platform=5&os='+os+'&code='+code+'&currentTime=' + date + '&account=' + encodeURI(account) + '&vipLevel=' + vip + '&extendInfo=' + extendInfo+'&sign='+sign).then(function (response) {
        if(response.data.code == 1){
          vm.visitorMd5Code = response.data.data.visitorMd5Code;
          if (response.data.data.visitorStyle) {
            vm.boxBodyColor = response.data.data.visitorStyle.boxBodyColor;
            console.log("this.boxBodyColor:"+vm.boxBodyColor)
          }
          if(customFlag == 1) {
            vm.asyncGetNotify(vm.visitorMd5Code)
          }else {
            sessionStorage.setItem('md5',vm.visitorMd5Code)

            vm.redirectTarget = response.data.data.redirectTarget
            sessionStorage.setItem('redirectTarget',vm.redirectTarget)

            if (vm.redirectTarget == 5) {
              // 首次进入页面埋点
              vm.$Points.point({code: '1000'});
            }

            vm.imEntranceMode = response.data.data.imEntranceMode

            sessionStorage.setItem('imEntranceMode',vm.imEntranceMode)
            sessionStorage.setItem('callCenterEnable',response.data.data.callCenterEnable);
            vm.status = response.data.data.status

            var customPicture = null
            var defaultPictureNo = null
            var headPictureUrl = null
            if(response.data.data.robotHead){
              customPicture = response.data.data.robotHead.customPicture
              defaultPictureNo = response.data.data.robotHead.defaultPictureNo
              headPictureUrl = response.data.data.robotHead.headPictureUrl
            }else {
              customPicture = false
              defaultPictureNo = 1
              headPictureUrl = null
            }
            sessionStorage.setItem('customPicture',customPicture)
            sessionStorage.setItem('defaultPictureNo',defaultPictureNo)
            sessionStorage.setItem('headPictureUrl',headPictureUrl)

            if(a.indexOf("handinviteis=1")>-1 || a.indexOf("inviteis=1")>-1){
              console.log('-----------------邀请进入的----------')
              sessionStorage.setItem("inviteis", true);
              sessionStorage.setItem('newSession',true);
            }

            if(a.indexOf("handinviteis=1")>-1){
              console.log('=================手动邀请会话================');
              sessionStorage.setItem('indexUrl','imSession');
              sessionStorage.setItem("inviteis", true);
              sessionStorage.setItem('newSession',true);
              vm.$router.replace({path: '/imSession', query: {v: vm.visitorMd5Code}})
              return
            }

            if (vm.status === 'chatting') {
              sessionStorage.setItem('indexUrl','imSession')
              vm.$router.replace({path: 'imSession'});
              return
            }
            if(a.indexOf("inviteis=1")>-1){
              console.log('=================主动邀请会话================');
              if (vm.imEntranceMode === 1) {
                console.log('統一入口')
                vm.axios.get(vm.basicUrl +'/api/visitor/initiative-invite/auto?visitorMd5Code='+vm.visitorMd5Code+'&entranceId=').then(function (resp) {
                  var data  = resp.data;
                  if(data.code == 1){

                    if(data.data.position == '0'){
                      sessionStorage.setItem('indexUrl','imSession');
                      sessionStorage.setItem("inviteis", true);
                      sessionStorage.setItem('newSession',true);
                      vm.$router.replace({path: '/imSession', query: {v: vm.visitorMd5Code}})
                    }else{
                      vm.$router.replace({path: '/ServiceError', query: {v: vm.visitorMd5Code,errType:'costomerErr'}})
                    }

                  }else if (data.code == 4211) {
                    sessionStorage.setItem("inviteis", false);
                    sessionStorage.setItem('newSession',false);
                    vm.$router.replace({path: '/imSession', query: {v: vm.visitorMd5Code}})
                  }
                })

              } else if (vm.imEntranceMode === 2) {
                console.log('多入口')
                sessionStorage.setItem('indexUrl','inviteselect')
                vm.$router.replace({path: 'inviteselect'})
              }
              return
            }
            if (vm.redirectTarget === 5) {
              sessionStorage.setItem('indexUrl','aiInteractive')
              console.log('跳转到人撒旦法萨芬萨达工客服：', vm.visitorMd5Code)
              vm.$router.replace({path: 'aiInteractive', query: {v: vm.visitorMd5Code}})
              return
            }
            if (vm.redirectTarget === 3) {
              sessionStorage.setItem('indexUrl','workerorderindex')
              vm.$router.replace({path: 'workerorderindex'})
              return
            }

            if (vm.status === 'waiting') {
              sessionStorage.setItem('indexUrl','imLineUp')
              vm.$router.replace({path: 'imLineUp'})
              return
            }

            if (vm.redirectTarget === 2) {
              if (vm.imEntranceMode === 1) {
                console.log('統一入口')
                sessionStorage.setItem('indexUrl','imLineUp')
                vm.$router.replace({path: 'imLineUp'})
              } else if (vm.imEntranceMode === 2) {
                console.log('多入口')
                sessionStorage.setItem('indexUrl','imDirectory')
                vm.$router.replace({path: 'imDirectory'})
              } else {
                console.error('未知入口')
              }

            } else if (vm.redirectTarget === 1) {
              sessionStorage.setItem('indexUrl','spirit')
              vm.$router.replace({path: 'spirit'})
            } else if (vm.redirectTarget === 4) {
              sessionStorage.setItem('indexUrl','myorder')
              vm.$router.replace({path: 'myorder'})
            }
          }
        } else {
        }
      }, function (response) {
        console.info(response)
      })
    },
    asyncGetNotify(visitorMd5Code) {
      this.axios.get("/api/visitor/notify",{params: {'visitorMd5Code': visitorMd5Code}}).then(res=> {
        if (res.data.code === 1) {
          let data = res.data.data;
          if(data) {
            this.notifyTitle = data.title;
            this.notifyStartTime = data.startTime;
            this.notifyStartTime = new Date(parseInt(this.notifyStartTime)).format("yyyy-MM-dd hh:mm:ss")
            this.notifyContent = data.content;
            this.timer = setInterval(()=> {
              if(this.countDown>0) {
                this.countDown--
              }else {
                if(this.timer) clearInterval(this.timer)
              }
            },1000)
          }else {
            this.initConfig(2)
          }
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    //点击“进入”按钮
    jumpTo() {
      if(this.countDown>0) return;
      this.initConfig(2)
    },
    //点击“离开”按钮
    cancelWait() {
      window.close()
      /*if (window.rampage){
        console.log('SDK浏览器，关闭页面')
        window.rampage.actionClose()
      }else if(window.ReactNativeWebView){
        console.log('大神sdk关闭页面')
        window.ReactNativeWebView.postMessage('closekf');
      } else if(window.webkit){
        console.log('--------webkit--------')
        window.webkit.messageHandlers.CloseCurrentVC.postMessage(null)
      }else if(window.WeixinJSBridge) {
        console.log('微信浏览器，关闭页面')
        WeixinJSBridge.call('closeWindow')
      }else {
        window.close()
        // window.history.back();
      }*/
     /* this.axios.get(vm.basicUrl + '/api/visitor/im/cancelWait?visitorMd5Code='+this.visitorMd5Code).then((res) => {
        if(res.data.code===1) {
          // 主页为精灵或者IM既退出页面
          if (window.rampage){
            console.log('SDK浏览器，关闭页面')
            window.rampage.actionClose()
          }else if(window.ReactNativeWebView){
            console.log('大神sdk关闭页面')
            window.ReactNativeWebView.postMessage('closekf');
          } else if(window.webkit){
            console.log('--------webkit--------')
            window.webkit.messageHandlers.CloseCurrentVC.postMessage(null)
          }else if( window.WeixinJSBridge) {
            console.log('微信浏览器，关闭页面')
            WeixinJSBridge.call('closeWindow')
          }else {
            window.history.back();
          }
        }else {
          this.$message.error('取消排队失败，请稍后再试')
        }
      }, (err) => {
        console.log(err)
        window.history.back();
      })*/
    },
    getOs(){
      var sUserAgent = navigator.userAgent;
      console.log(navigator.platform,navigator)
      var isWin = (navigator.platform == "Win32") || (navigator.platform == "Windows") || (navigator.platform == "Win64");
      var isMac = (navigator.platform == "Mac68K") || (navigator.platform == "MacPPC") || (navigator.platform == "Macintosh") || (navigator.platform == "MacIntel");
      var isLinux = (String(navigator.platform).indexOf("Linux") > -1);
      var isAndroid = sUserAgent.indexOf('Android') > -1 || sUserAgent.indexOf('Linux') > -1
      var isIPhone = sUserAgent.indexOf('iPhone') > -1
      var isWindowsPhone = sUserAgent.indexOf('Windows Phone') > -1

      if (isIPhone) return 1;
      if (isAndroid) return 2;
      if (isWindowsPhone) return 3;

      if (isMac) return 5;
      if (isWin) return 6;
      if (isLinux) return 7;

    }
  },
  beforeDestroy() {
    if(this.timer) clearInterval(this.timer)
  }
}
</script>

<style scoped>
.notify-container {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: #ebebeb;
  display: flex;
  flex-direction: column;
}
.header-box {
  background-color: #fff;
  padding: 10px 14px 8px;
  flex: 0 1 auto;
  border-bottom: 1px solid #eee;
}
.header-box .notify-text {
  font-size: 19px;
  font-weight: bold;
  display: block;
  color: #333;
}
.header-box .notify-time {
  font-size: 13px;
  display: block;
  margin-top: 8px;
  color: #999;
}
.content-box {
  background-color: #fff;
  overflow: auto;
  padding: 15px 15px 50px;
  flex: 1;
}
#notify-content {
  white-space: pre-wrap;
  word-break: break-word;
}
.footer-box {
  flex: 0 1 50px;
  display: flex;
  align-items: center;
  background-color: #fff;
  border-top: 1px solid #eee;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  box-sizing: border-box;
}
.footer-box .btn {
  flex: 1;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 14px;
  cursor: pointer;
  width: 49.5%;
  display: inline-block;
}
.footer-box .btn.disable {
  background: #ccc;
  color: #fff;
}
.footer-box .btn.ok {
  background: #009588;
  color: #fff;
}
/*IE9以上*/
@media screen and (min-width:0\0)  {
  .content-box {
    position: absolute;
    top: 64px;
    bottom: 50px;
  }
  #notify-content {
    white-space: pre;
    word-break: break-all;
  }
  .footer-box .btn {
    float: left;
    width: 50%;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Hello.vue?353c427b